import { Component, Input } from '@angular/core';
import { ApiKey } from '../../../models/api-key';

@Component({
    selector: 'agpr-media-monitoring-api-key-card',
    templateUrl: './media-monitoring-api-key-card.component.html',
    styleUrls: ['./media-monitoring-api-key-card.component.scss'],
    standalone: false
})
export class MediaMonitoringApiKeyCardComponent {
    @Input() apiKey: ApiKey;
}
